import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    dividerWide: {
      backgroundColor: COLORS.primary.light,
      marginTop: theme.spacing(1),
    },
  }),
  { name: 'BlockCollapse' }
);
